export default "__VITE_ASSET__BU07evVm__"